export default __webpack_public_path__ + "static/media/bg2.e5f75497.jpg";